import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OrderForm from "./OrderForm";
import { Confirmed } from 'assets/images'
import { Button } from "@mui/material";

const OrderConfirmedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const location = useLocation();
  const login_res = location?.state?.login_res

  return (
    <div className="grid grid-cols-3 h-screen w-screen bg-[#F7F7F8] p-2">


      <div className="col-span-2 flex justify-center items-center content-center w-full h-full bg-white rounded-2xl p-[40px]">

        <div className="w-[380px] justify-center items-center content-center text-center ">
          <img src={Confirmed} alt="" />
          <p className="text-sm text-[#828282] font-normal">Step 5 {t("OF").toLowerCase()} 5</p>
          <p className="text-3xl text-black font-semibold mt-4">{t("Pay.OrderConfirmed")}</p>
          <p className="text-base text-[#828282] font-normal mt-2 ">{t("Pay.OrderConfirmedSubtitle")}</p>
          <Button
            onClick={() => {
              localStorage.removeItem('plan')
              localStorage.removeItem('discount')
              localStorage.removeItem('registrationToken')
              navigate('/cases')
            }}
            variant="contained"

            sx={{
              marginTop: "32px",
              paddingLeft: "22px",
              paddingRight: "22px",
              fontWeight: 600,
              backgroundColor: "#0049EE",
              fontSize: "16px",
              textTransform: "none",
            }}
          >
            {t("Pay.GoToPlatform")}
          </Button>
        </div>









      </div>

      {/* Sidebar con dettagli */}
      <OrderForm showDiscount={true} login_res={login_res} />
    </div>
  );
};

export default OrderConfirmedPage;
